<template>
	<div class="accountSetting securitySetting pl-xl-4">
        <div class="border-bottom pb-4 mb-4">
            <h3 class="medium mb-2"> Privacy Options</h3>
            <div class="d-flex align-items-center justify-content-between">
                <p class="mb-0 f-14">Control what you share on Capital Wallet</p>
                <a href="javascript:void(0)" class="flex-shrink-0 small cap_btn-b">Learn More</a>
            </div>
        </div>
        <div class="border-bottom pb-4 mb-4">
            <h5 class="medium mb-4">Your Capital Wallet Account</h5>
            <div class="d-flex align-items-center justify-content-between mb-4">
                <p class="mb-0">You have a number of rights over your personal data. For more detailed information on these choices, please read our full <a href="javascript:void(0)">Privacy Policy</a> and our <a href="javascript:void(0)">Cookie Policy</a></p>
            </div>
        </div>
        <div class="border-bottom pb-4 mb-4">
            <h5 class="medium mb-1">Request Data</h5>
            <div class="d-flex align-items-center justify-content-between">
                <p class="mb-0">Request a copy of my personal data held by Capital Wallet</p>
                <a href="javascript:void(0)" class="cap_btn-b small">Request Data</a>
            </div>
        </div>
        <div class="border-bottom pb-4 mb-4">
            <h5 class="medium mb-1">Request Deletion</h5>
            <div class="d-flex align-items-center justify-content-between">
                <p class="mb-0">Request deletion of some or all of my data</p>
                <a href="javascript:void(0)" class="cap_btn-b small">Request Deletion</a>
            </div>
        </div>
        <div class="border-bottom pb-4 mb-4">
            <h5 class="medium mb-1">Request Export</h5>
            <div class="d-flex align-items-center justify-content-between">
                <p class="mb-0">Request export of my data in a machine-readable form</p>
                <a href="javascript:void(0)" class="cap_btn-b small">Request Data Export</a>
            </div>
        </div>
        <div class="border-bottom pb-4 mb-4">
            <h5 class="medium mb-1">Request Correction</h5>
            <div class="d-flex align-items-center justify-content-between">
                <p class="mb-0">Request to correct, modify, or complete my data</p>
                <a href="javascript:void(0)" class="cap_btn-b small">Request Correction</a>
            </div>
        </div>
        <div class="border-bottom pb-4 mb-4">
            <h5 class="medium mb-1">Manage Cookies</h5>
            <div class="d-flex align-items-center justify-content-between">
                <p class="mb-0">Manage your cookie preferences</p>
                <a href="javascript:void(0)" class="cap_btn-b small">Manage Cookies</a>
            </div>
        </div>
        <!-- <div class="buttons d-flex align-items-center justify-content-end mt-4">
            <a href="javascript:void(0)" class="cap_btn-b mr-3 min-auto">Cancel</a>
            <a href="javascript:void(0)" class="cap_btn small">Save</a>
        </div> -->
    </div>
</template>

<script>
import { registerStepsMixins } from '@/plugins/registerSteps'
// import editAddress from './edit_Address'
// import editNumber from './edit_Number'
export default {
    name: 'accountprofile',
    mixins: [registerStepsMixins],
    data() {
        return {
            notification_msg:'',
            notification_type:'',
            // tab: '1',
            submitted: false,
            // editAddress: false,
            // editNumber: false,

            fname: '',
            mName: '',
            lname: '',
            dob: '',
            address: '',
            city: '',
            state: '',
            country: '',
            area_code: '',
            acc_type: '',
            OrganizationType:{
            	'0':'Company',
            	'1':'Self Managed Super Fund',
            	'2':'Discretionary/Unit Trust',
            	'3':'Others'
            }
        }
    },
    components:{
        // editAddress,
        // editNumber 
    },

    methods: {
        create_image(url,name){
            var stx = this.stxx
            var link = document.createElement('a');
            link.download = name;
            link.href = url
            link.click();
        },
        ChangeTab(val){
            this.tab = val
            // this.editAddress = false
            // this.editNumber = false
            this.pageLoader = false
        },
        Submit() {
            const _that = this
            _that.submitted = true;
            _that.$validator.validate().then(valid => {
                if (valid) {
                    let input_json = {
                        'globalParams': {
                            'f_name': _that.fname,
                            'm_name': _that.mName,
                            'l_name': _that.lname,
                            'dob': _that.dob,
                            'Address': _that.address,
                            'City': _that.city,
                            'State': _that.state,
                            'Country': _that.country,
                            'Areacode': _that.area_code,
                            'Acc_type': _that.acc_type,
                        },
                        localParams: {
                            "parameter": _that
                        }
                    }

                }
            });
        }
    },
    created() {
        this.pageName('Account Profile')
        this._runGetProfileInfo({
            globalParams: {
				
			},
            localParams: {
                "parameter": this
            }
        })
    }
}
</script>



// WEBPACK FOOTER //
// src/components/website/settings/files/privacy.vue